import { AlbumRepository } from '../../data/local/albumRepository'
import { MediaRepository } from '../../data/local/mediaRepository'
import { caravanDb } from '../../services/syncRuntime'

export const mediaRepository = new MediaRepository(caravanDb)
export const albumRepository = new AlbumRepository(caravanDb, mediaRepository)
